import React, { useState } from "react";
import { useNavigate, Navigate } from 'react-router-dom';
import { baseUrl } from "../shared";
import '../pages/App.css';
import { Toggle } from './ui';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// Striped permission row (shared 1MS pattern: label + token Toggle, alternating rows).
function PermissionRow({ label, checked, onToggle, index }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1.25,
        background: index % 2 === 0 ? 'var(--surface-2)' : 'var(--surface)',
      }}
    >
      <Typography sx={{ fontSize: 14 }}>{label}</Typography>
      <Toggle checked={checked} onChange={onToggle} ariaLabel={label} />
    </Box>
  );
}

export function Register() {
  const [usernameReg, setUsernameReg] = useState("");
  const [passwordReg, setPasswordReg] = useState("");
  const [nameReg, setNameReg] = useState("");
  const [phoneReg, setPhoneReg] = useState("");
  const [emailReg, setEmailReg] = useState("");
  const [isPayrollReg, setIsPayrollReg] = useState(0);
  const [isConsultantReg, setIsConsultantReg] = useState(0);
  const [defaultRateReg, setDefaultRateReg] = useState(0);
  const [canAdminReg, setCanAdminReg] = useState(0);
  const [canApproveConsultantReg, setCanApproveConsultantReg] = useState(0);
  const [canApprovePayrollReg, setCanApprovePayrollReg] = useState(0);
  const [canPayoutReg, setCanPayoutReg] = useState(0);
  const navigate = useNavigate();

  const [createNewUser] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [errOpen, setErrOpen] = React.useState(false);
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setOpen(false);
    <Navigate to={'/admin/'} />;
    { navigate(0); }
  };

  const handleErrClose = () => {
    setErrOpen(false);
  };

  const cancelCreateUser = () => {
    <Navigate to={'/admin/'} />;
    { navigate(0); }
  };

  const sendCreateUser = async () => {
    const url = baseUrl + "user/register";
    var payload = {
      "username": usernameReg,
      "password": passwordReg,
      "name": nameReg,
      "phone": phoneReg,
      "email": emailReg,
      "isPayroll": isPayrollReg,
      "isConsultant": isConsultantReg,
      "defaultRate": defaultRateReg,
      "canAdmin": canAdminReg,
      "canApproveConsultant": canApproveConsultantReg,
      "canApprovePayroll": canApprovePayrollReg,
      "canPayout": canPayoutReg,
    };
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
      },
      body: ("json", JSON.stringify(payload)),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setMessage(data.message);
          setOpen(true);
        } else if (data.status === 401) {
          setMessage(data.message);
          setErrOpen(true);
        }
      })
      .catch((err) => {
        setMessage(err.message);
        setOpen(true);
      });
  };

  if (!(createNewUser && localStorage.getItem('canAdmin') === '1')) return null;

  return (
    <Card sx={{ p: { xs: 2.5, md: 3.5 }, maxWidth: 560, mx: 'auto' }}>
      <React.Fragment>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <React.Fragment>
        <Dialog open={errOpen} onClose={handleErrClose}>
          <DialogTitle />
          <DialogContent>
            <DialogContentText>{message}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleErrClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>

      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Register New User</Typography>

      <TextField fullWidth required margin="dense" label="Username" variant="outlined" type="text" onChange={(e) => setUsernameReg(e.target.value)} />
      <TextField fullWidth required margin="dense" label="Password" variant="outlined" type="password" onChange={(e) => setPasswordReg(e.target.value)} />
      <TextField fullWidth required margin="dense" label="Name" variant="outlined" type="text" onChange={(e) => setNameReg(e.target.value)} />
      <TextField fullWidth required margin="dense" label="Phone Number" variant="outlined" type="text" onChange={(e) => setPhoneReg(e.target.value)} />
      <TextField fullWidth required margin="dense" label="E-Mail Address" variant="outlined" type="text" onChange={(e) => setEmailReg(e.target.value)} />
      <TextField fullWidth required margin="dense" label="Default Rate" variant="outlined" type="text" onChange={(e) => setDefaultRateReg(e.target.value)} />

      <Typography sx={{ mt: 2.5, mb: 1, fontWeight: 700, fontSize: 13, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.4px' }}>
        Permissions
      </Typography>
      <Box sx={{ border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden' }}>
        <PermissionRow index={0} label="Is Payroll User" checked={isPayrollReg} onToggle={() => setIsPayrollReg(isPayrollReg ? 0 : 1)} />
        <PermissionRow index={1} label="Is Consultant User" checked={isConsultantReg} onToggle={() => setIsConsultantReg(isConsultantReg ? 0 : 1)} />
        <PermissionRow index={2} label="Can Perform Admin Functions" checked={canAdminReg} onToggle={() => setCanAdminReg(canAdminReg ? 0 : 1)} />
        <PermissionRow index={3} label="Can Approve Consultant Time" checked={canApproveConsultantReg} onToggle={() => setCanApproveConsultantReg(canApproveConsultantReg ? 0 : 1)} />
        <PermissionRow index={4} label="Can Approve Payroll Time" checked={canApprovePayrollReg} onToggle={() => setCanApprovePayrollReg(canApprovePayrollReg ? 0 : 1)} />
        <PermissionRow index={5} label="Can Payout Money" checked={canPayoutReg} onToggle={() => setCanPayoutReg(canPayoutReg ? 0 : 1)} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={cancelCreateUser}>Cancel</Button>
        <Button variant="contained" onClick={sendCreateUser}>Register</Button>
      </Box>
    </Card>
  );
}

export default Register;
